import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';


const filterState = {
    accounts: null,
    start_date: null,
    end_date: null,
};

const filterSchema = Yup.object().shape({
    accounts: Yup.array().min(1).required(),
    start_date: Yup.date().nullable(),
    end_date: Yup.date().nullable(),
});


const filterFormFields = [
    { name: "accounts", title: "Ledgers", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "title", itemValue: "id" },
    { name: "start_date", title: "Start Date", required: false, type: VALUE_TYPES.DATEPICKER, disabled: false },
    { name: "end_date", title: "End Date", required: false, type: VALUE_TYPES.DATEPICKER, disabled: false },
];

export const filterConfig = {
    "state": filterState,
    "schema": filterSchema,
    "formFields": filterFormFields
};